export default angular.module('contartemx.preferencias.descuentos', [
	'contartemx',
	'ui.router',
	'ui.bootstrap'
])
.controller('DescuentosCtrl', function ($scope, $state, $stateParams, callToWebService, $filter) {



		callToWebService.postCall('ObtenerDescuentos', {},
			function success(data){
				$scope.descuentosIndiv = $filter('orderBy')(data.Respuesta.Descuentos, 'Monto');
				$scope.descuentosGlob = $filter('orderBy')(data.Respuesta.DescuentosGlobales, 'Monto');
			},
			function error(data){
				$scope.mostrarNotificacion(true,data.Mensaje, true);
			});

		$scope.editDescuento = function(index, type){
			if(index > -1)
			{
				if(type < 1)
				{
					$scope.editIndRow = index;
					$scope.origVal = $scope.descuentosIndiv[index].Monto;
				}
				else
				{
					$scope.editGlobRow = index;
					$scope.origVal = $scope.descuentosGlob[index].Monto;
				}
				$scope.newIndiv = false;
				$scope.newGlob = false;
			}
		};

		$scope.addDescuento = function (type){
			
			if(type < 1)
			{
				
				$scope.editDescuento(-1,type);
				$scope.newIndiv = true;
				$scope.newDescuentoInd="";
				
			}
			else
			{
				$scope.editDescuento(-1,type);
				$scope.newGlob = true;
				$scope.newDescuentoGlob="";
			}

			$scope.editGlobRow = -1;
			$scope.editIndRow = -1;
		};

		$scope.cancelNew = function(){
			$scope.newIndiv = false;
			$scope.newGlob =false;
			$scope.newDescuentoInd="";
			$scope.newDescuentoGlob="";
		};

		$scope.saveDescuento = function(type, valor){

			if(typeof parseInt(valor) === 'number' && parseInt(valor) > -1)
			{
				$scope.origVal = null;
				var cveCuenta;
				var newValue;
				if(type < 1){
					cveCuenta = ($scope.editIndRow > -1) ? $scope.descuentosIndiv[$scope.editIndRow].CveCuenta:0;
					newValue = ($scope.editIndRow > -1) ? $scope.descuentosIndiv[$scope.editIndRow].Monto:valor;
				}
				else{
					cveCuenta = ($scope.editGlobRow > -1) ? $scope.descuentosGlob[$scope.editGlobRow].CveCuenta:0;
					newValue = ($scope.editGlobRow > -1) ? $scope.descuentosGlob[$scope.editGlobRow].Monto:valor;
				}

				var newDescuento = {
					Numero: (type < 1) ? 4991000:4990000,
					Monto: newValue,
					CveCuenta: cveCuenta
				};

				callToWebService.postCall('CrearEditarDescuento', {descuento:newDescuento},
					function success(data){
						if(data.CodigoRespuesta !== 500)
						{
							if(type < 1)
							{
								if(data.Respuesta.EsNuevo)
								{
									
									$scope.descuentosIndiv.push(data.Respuesta);
									$scope.newIndiv = false;
								}
								else
								{
									$scope.descuentosIndiv[$scope.editIndRow] = data.Respuesta;
								}
								$scope.editIndRow = -1;
								$scope.descuentosIndiv = $filter('orderBy')($scope.descuentosIndiv, 'Monto');
							}
							else
							{
								if(data.Respuesta.EsNuevo)
								{
									$scope.descuentosGlob.push(data.Respuesta);
									$scope.newGlob = false;
								}
								else
								{
									$scope.descuentosGlob[$scope.editGlobRow] = data.Respuesta;
								}
								$scope.editGlobRow = -1;
								$scope.descuentosGlob = $filter('orderBy')($scope.descuentosGlob, 'Monto');
							}

							$scope.showMsg(data.Mensaje, 'info');
						}
						else
						{
							$scope.showMsg(data.Mensaje, 'error');
							if(type<1){
								$scope.origVal=$scope.descuentosIndiv[$scope.editIndRow].Monto;
							}
							else{
								$scope.origVal=$scope.descuentosGlob[$scope.editIndRow].Monto;
							}

							
						}
					},
					function error(data){
						
						 $scope.showMsg(data.Mensaje, 'error');
					});
			}
			else{
				$scope.showMsg('Debe poner un valor numerico positivo para agregar un descuento', 'error');
			}
		};

		$scope.deselectInd = function () {
			if($scope.editIndRow > -1)
			{
				if(isNaN(parseInt($scope.descuentosIndiv[$scope.editIndRow].Monto)) || $scope.descuentosIndiv[$scope.editIndRow].Monto != $scope.origVal)
				{
					$scope.descuentosIndiv[$scope.editIndRow].Monto = $scope.origVal;
				}
				$scope.origVal = null;
				$scope.editIndRow = -1;
			}
		};

		$scope.deselectGlob = function () {
			if($scope.editGlobRow > -1)
			{
				if(isNaN(parseInt($scope.descuentosGlob[$scope.editGlobRow].Monto)) || $scope.descuentosGlob[$scope.editGlobRow].Monto != $scope.origVal)
				{
					$scope.descuentosGlob[$scope.editGlobRow].Monto = $scope.origVal;
				}
				$scope.origVal = null;
				$scope.editGlobRow = -1;
			}
		};

		$scope.deleteDescuento = function(type){
			
			var cveCuenta;
			if(type < 1){
				cveCuenta = $scope.descuentosIndiv[$scope.editIndRow].CveCuenta;
			}
			else{
				cveCuenta = $scope.descuentosGlob[$scope.editGlobRow].CveCuenta;
			}

			callToWebService.postCall('DesactivarDescuento', {CveCuenta:cveCuenta},
				function success(data){
					
					if(!data.EsError)
					{
						if(type < 1)
						{
							$scope.descuentosIndiv.splice($scope.editIndRow, 1);
							$scope.editIndRow = -1;
						}
						else{
							$scope.descuentosGlob.splice($scope.editGlobRow, 1);
							$scope.editGlobRow = -1;
						}

						$scope.showMsg('Descuento eliminado correctamente', 'info');
					}
					else
					{
						$scope.showMsg('Ocurrio un error al intentar borrar el descuento', 'error');
					}
				}
			);
		};

		$scope.alert = [];

		$scope.showMsg = function(mensaje, tipo){
			$scope.alert = [];
			$scope.alert.push({type:tipo, msg:mensaje});
		};

		$scope.closeAlert = function(){
			$scope.alert = [];
		};
});

